import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router";
import { ROUTES } from "../../../../constant/routeConstant";
import { deleteSkillset, editSkillset, getDetailSkillset, getListSkillset, getListSkillsetDropdown, getManagementHistoryList, getSearchRecommendation, getSearchResult, initiateSkillset, postSkillset } from '../../../../service/master/Skillset/SkillsetService';
import moment from 'moment';

export const useSkillset = () => {
    const { token } = useSelector((state) => state.auth);

    const [successModalOpen, setSuccessModalOpen] = useState(false)
    const [deleteConfirmationModalOpen, setDeleteConfirmationModalOpen] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)

    const [selectedId, setSelectedId] = useState()
    const [selectedUpdatedAt, setSelectedUpdatedAt] = useState()

    const [dataToCompare, setDataToCompare] = useState()

    const [totalData, setTotalData] = useState()

    const [list, setList] = useState([])
    const [listDropdown, setListDropdown] = useState([])

    const [options, setOptions] = useState([])

    const [detailSkillset, setDetailSkillset] = useState({})

    const [skillsetType, setSkillsetType] = useState('')
    const [skillsetName, setSkillsetName] = useState('')
    const [skillsetDescription, setSkillsetDescription] = useState('')

    const [searchKeyword, setSearchKeyword] = useState()

    const [pageLimit, setPageLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [selectedDepotId, setSelectedDepotId] = useState()

    const [skillsetTypeError, setSkillsetTypeError] = useState(false)
    const [skillsetNameError, setSkillsetNameError] = useState(false)
    const [skillsetDescriptionError, setSkillsetDescriptionError] = useState(false)

    const [managementHistoryList, setManagementHistoryList] = useState([])

    const [statePageSize, setStatePageSize] = useState(10)

    const dispatch = useDispatch();

    const [sorting, setSorting] = useState("skillset_name asc")

    const [currentPage, setCurrentPage] = useState(1)

    const [dropdownListLoading, setDropdownListLoading] = useState(false)
    const [depotKeyword, setDepotKeyword] = useState('')
    const [depotListPage, setDepotListPage] = useState(1)

    const navigate = useNavigate();

    const doSort = (sort) => {
        setSorting(sort);
        doGetListSkillset(selectedDepotId, page, pageLimit, sort);
    }

    const toAddSkillset = () => {
        navigate(ROUTES.SKILLSET.ADD, {
            state: {
                depotId: selectedDepotId
            }
        })
    }

    const onSearch = (event) => {
        let keyword = event.target.value
        setSearchKeyword(keyword)
        doSearch(keyword)
    }

    const toEditSkillSet = (data) => {
        navigate(ROUTES.SKILLSET.EDIT, {
            state: {
                data
            }
        })
    }

    const toDetailSkillSet = (id) => {
        navigate(ROUTES.SKILLSET.DETAIL, {
            state: {
                id
            }
        })
    }

    const handlePagination = (page, pageSize, selectedDepotId) => {
        setPage(page)
        setPageLimit(pageSize)
        doInitializeSkillset(selectedDepotId, page, pageSize)
        doGetListSkillset(selectedDepotId, page, pageSize)
    }

    const onScroll = (event, namespace) => {
        let target = event.target
        switch (namespace) {
            case 'depotList':
                if (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight || (target.scrollHeight - Math.ceil(target.scrollTop) === target.clientHeight + 1) && !dropdownListLoading) {
                    doGetListDropdown(depotListPage + 1, depotKeyword)
                    setDepotListPage(depotListPage + 1)
                    target.scrollTo(0, target.scrollHeight);
                }
                break;

            default:
                break;
        }
    }

    const onSearchDDS = (keyword, namespace) => {
        switch (namespace) {
            case 'depotList':
                setDepotKeyword(keyword)
                if (keyword.length >= 3 || keyword === '') {
                    doGetListDropdown(1, keyword, 'searchList')
                }
                setDepotListPage(1)
                break;

            default:
                break;
        }
    }

    const doSearch = async (keyword) => {
        try {
            const response = await getSearchRecommendation(token, null, selectedDepotId, keyword, dispatch);
            if (response && response.ok) {
                setOptions(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSelect = async (keyword) => {
        try {
            const response = await getSearchResult(token, null, selectedDepotId, keyword, dispatch);
            if (response && response.ok) {
                doInitializeSkillset(selectedDepotId, page, pageLimit, keyword)
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doInitializeSkillset = async (selectedDepotId, page, pageSize, keyword) => {
        const param = `page=${page}&limit=${pageSize}&filter=depot_id eq ${selectedDepotId}${keyword ? `, skillset_name lk ${keyword}` : ''}`
        try {
            if (selectedDepotId) {
                const response = await initiateSkillset(token, null, param, dispatch);
                if (response && response.ok) {
                    setTotalData(response.data.count_data)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetDetailSkillset = async (id) => {
        try {
            const response = await getDetailSkillset(token, null, id, dispatch);
            if (response && response.ok) {
                setDetailSkillset(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetManagementHistoryList = async (id) => {
        try {
            const response = await getManagementHistoryList(token, null, dispatch, id);
            if (response && response.ok) {
                const data = response.data
                const reorderedData = []

                for (let i = data.length - 1; i >= 0; i--) {
                    const element = data[i];
                    reorderedData.push(element)
                }

                setManagementHistoryList(reorderedData)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetListSkillset = async (selectedDepotId, page, pageLimit, sort) => {
        setSearchKeyword()
        const param = `page=${page}&limit=${pageLimit}&order=${typeof sort !== 'undefined' ? sort : `skillset_name asc`}`

        try {
            const response = await getListSkillset(token, null, param, selectedDepotId, dispatch);
            setSearchKeyword(null)
            if (response && response.ok) {
                setList(response.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doGetListDropdown = async (page, keyword = '', flags = 'list') => {
        setDropdownListLoading(true)
        try {
            const response = await getListSkillsetDropdown(token, page, keyword, null, dispatch);
            if (response && response.ok) {
                // setSelectedDepotId(response.data[0].id)
                
        let option = [];
        if (response.data !== null && response.data.length !== undefined) {
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            let data = {
              id: element.depot_id,
              value: element.depot_name,
            };
            option.push(data);
          }
        }
        if (flags === "list") {
          if (listDropdown.length === 0) {
            setListDropdown(option);
          } else {
            let tempListDropdown = [...listDropdown];
            option.map((item) => tempListDropdown.push(item));
            setListDropdown(tempListDropdown);
          }
        //   setDropdownListloading(false);
        } else if (flags === "searchList") {
          setListDropdown(option);
        }
      }
        } catch (error) {
            console.log(error)
        }
    }

    const doClear = (depot_id) => {
        setSearchKeyword()
        doInitializeSkillset(depot_id, 1, 10)
        doGetListSkillset(depot_id, 1, 10)
    }

    const doPostSkillset = async (depot_id) => {
        if (checkForm()) {
            let data = {
                'depot_id': depot_id,
                'skill_set_type': skillsetType,
                'skill_set_name': skillsetName,
                'description': skillsetDescription
            }

            try {
                const response = await postSkillset(token, null, data, dispatch)
                if (response && response.ok) {
                    setSuccessModalOpen(true)
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    const checkForm = () => {
        if (skillsetType !== '' && skillsetName !== '' && skillsetDescription !== '') {
            return true
        } else {
            if (skillsetType === '') {
                setSkillsetTypeError(true)
            }
            if (skillsetName === '') {
                setSkillsetNameError(true)
            }
            if (skillsetDescription === '') {
                setSkillsetDescriptionError(true)
            }
            return false
        }
    }

    const doDeleteSkillset = async () => {
        try {
            const response = await deleteSkillset(token, null, selectedId, selectedUpdatedAt, dispatch)
            if (response && response.ok) {
                setDeleteConfirmationModalOpen(false)
                setSuccessModalOpen(true)
                setSelectedId()
                setSelectedUpdatedAt()
                doGetListSkillset(selectedDepotId, 1, 10)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const doEditSkillset = async (data) => {
        if (checkForm()) {
            const updatedData = {
                "depot_id": data.depot_id,
                "skill_set_type": skillsetType,
                "skill_set_name": skillsetName,
                "description": skillsetDescription,
                "updated_at": data.updated_at
            }
            try {
                const response = await editSkillset(token, null, data.skill_set_id, updatedData, dispatch)
                if (response && response.ok) {
                    setSuccessModalOpen(true)
                    setSelectedId()
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    const selectDepotId = async (id, page, pageLimit) => {
        setSelectedDepotId(id)
        handleChangeLimit(page, pageLimit, id)
    }

    const handleChangeLimit = (page, value, selectedDepotId) => {
        setStatePageSize(value)
        setCurrentPage(page)
        handlePagination(page, value, selectedDepotId)
    }

    const selectPageLimit = async (limit) => {
        setPageLimit(limit)
        await doGetListSkillset(selectedDepotId)
    }

    const deleteConfirmation = (id, updated_at) => {
        setDeleteConfirmationModalOpen(true)
        setSelectedId(id)
        setSelectedUpdatedAt(updated_at)
    }

    useEffect(() => {
        doGetListDropdown(depotListPage)

        // if (selectedDepotId !== undefined) {
        //     doInitializeSkillset(selectedDepotId, 1, 10)
        //     doGetListSkillset(selectedDepotId, 1, 10)
        // }

        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (!selectedDepotId && listDropdown?.length > 0) {
          doInitializeSkillset(listDropdown[0]?.id, 1, 10);
          doGetListSkillset(listDropdown[0]?.id, 1, 10);
          setSelectedDepotId(listDropdown[0]);
        //   setIsLoaded(true);
        }
      }, [listDropdown]);
    const setEditedData = (data) => {
        setSkillsetType(data.skill_set_type)
        setSkillsetName(data.skill_set_name)
        setSkillsetDescription(data.description)
        setDataToCompare(data)
    }

    const onChange = (event, namespace) => {
        switch (namespace) {
            case 'skillset_type':
                if (event !== null) {
                    setSkillsetTypeError(false)
                    setSkillsetType(event)
                } else {
                    setSkillsetTypeError(true)
                }
                break;
            case 'skillset_name':
                if (event.target.value !== null) {
                    setSkillsetNameError(false)
                    setSkillsetName(event.target.value)
                } else {
                    setSkillsetNameError(true)
                }
                break;
            case 'description':
                if (event.target.value !== null) {
                    setSkillsetDescriptionError(false)
                    setSkillsetDescription(event.target.value)
                } else {
                    setSkillsetDescriptionError(true)
                }
                break;
            default:
                break;
        }

    }

    const isClear = () => {
        if (skillsetType || skillsetName || skillsetDescription) {
            return false
        } else {
            return true
        }
    }

    const isEdited = () => {
        if ((dataToCompare?.skill_set_type !== skillsetType) || (dataToCompare?.skill_set_name !== skillsetName) || (dataToCompare?.description !== skillsetDescription)) {
            return true
        } else {
            return false
        }
    }

    const convertTimestamp = (timestamp, isSpecific) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
        ];
        const monthNumbers = ["01", "02", "03", "04", "05", "06",
            "07", "08", "09", "10", "11", "12"
        ];

        // Extract components from the timestamp string
        const year = timestamp?.substring(0, 4);
        const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
        const day = timestamp?.substring(8, 10);

        let dateFormat = new Date(year, month, day);

        if (isSpecific) {
            return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
        } else {
            return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
        }
    }

    const convertToTime = (timestamp) => {
        let time = new Date(timestamp);
        return (moment(timestamp).utc().format('HH:mm'))
    }

    return {
        list,
        listDropdown,
        doPostSkillset,
        onChange,
        successModalOpen,
        skillsetType,
        doDeleteSkillset,
        deleteConfirmation,
        deleteConfirmationModalOpen,
        setDeleteConfirmationModalOpen,
        selectedId,
        setSuccessModalOpen,
        toAddSkillset,
        toEditSkillSet,
        toDetailSkillSet,
        doEditSkillset,
        setEditedData,
        doGetDetailSkillset,
        detailSkillset,
        convertTimestamp,
        convertToTime,
        options,
        onSearch,
        onSelect,
        doGetListSkillset,
        searchKeyword,
        pageLimit,
        setPageLimit,
        selectedDepotId,
        setSelectedDepotId,
        selectDepotId,
        page,
        setPage,
        selectPageLimit,
        totalData,
        handlePagination,
        setShowConfirm,
        showConfirm,
        isClear,
        isEdited,
        skillsetTypeError,
        skillsetNameError,
        skillsetDescriptionError,
        doSort,
        sorting,
        statePageSize,
        handleChangeLimit,
        doClear,
        doGetManagementHistoryList,
        managementHistoryList,
        currentPage,
        onScroll,
        onSearchDDS,
        dropdownListLoading,
        depotKeyword
    }
}